import { call, put, takeLatest } from 'redux-saga/effects';

import { inviteUserStart } from './actions';
import { loading, success, failure } from './slice';
import { inviteUser } from './service';
import { Action } from '@reduxjs/toolkit';

function* inviteUserFlow(action: Action<unknown>) {
  if (inviteUserStart.match(action)) {
    try {
      yield put(loading());
      yield call(inviteUser, action.payload);
      yield put(success());
    } catch (error) {
      const { message }: { message: string } = error?.response?.data || error;
      const statusCode: number = error?.response?.status;
      yield put(failure({ message, statusCode }));
    }
  }
}

export function* onInviteUserStart() {
  yield takeLatest(inviteUserStart, inviteUserFlow);
}
